"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _ravenJs = _interopRequireDefault(require("raven-js"));

var _interceptor = _interopRequireDefault(require("./interceptor"));

var _config = require("./utils/config");

var _validate = _interopRequireDefault(require("./utils/validate"));

var _resourceCapture = _interopRequireDefault(require("./resourceCapture"));

var extraCapture = _interopRequireWildcard(require("./extraCapture"));

var _constants = require("./constants");

var _middlewares = require("./middlewares");

var _ravenExtend = require("./utils/ravenExtend");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var kepler = {
  // 配置
  setConfig: _config.setConfig,
  // 安装
  install: function install(opts) {
    // 验证参数
    (0, _validate.default)(opts); // 初始化配置

    this.setConfig(Object.assign({
      reportDelay: _constants.REPORT_DELAY,
      reportMaxCount: _constants.REPORT_MAX_COUNT,
      httpThreshold: _constants.HTTP_TIMEOUT
    }, opts));
    var _opts$ignoreErrors = opts.ignoreErrors,
        ignoreErrors = _opts$ignoreErrors === void 0 ? [] : _opts$ignoreErrors,
        extraReport = opts.extraReport,
        _opts$console = opts.console,
        console = _opts$console === void 0 ? true : _opts$console; // 为了保证正常调用Raven.config，默认传入如下参数，在格式化处理的时候改写上报url即可

    _ravenJs.default.config('https://336ae60ca7b244a6b4e44cf8b955fe2e@sentry.io/1213463', {
      ignoreErrors: ignoreErrors,
      // 是否覆盖 console，覆盖原 console 方法，则 console 可被收集到 braeadcrumbs
      // https://github.com/getsentry/sentry-javascript/issues/584
      autoBreadcrumbs: {
        console: console
      }
    }).install(); // 拦截上报


    _ravenJs.default.setTransport(_interceptor.default.applyMiddleware(_middlewares.filter, _middlewares.storage, _middlewares.delay, _middlewares.merge, _middlewares.rootFormat, _middlewares.compress, _middlewares.rootReport, _middlewares.complete)); // 资源异常


    (0, _resourceCapture.default)(); // 上报更多数据

    extraCapture.install(_objectSpread({
      browserInfo: true,
      pageTime: true,
      useFrequency: true
    }, extraReport));
    extraCapture.setTransport(_interceptor.default.applyMiddleware(_middlewares.delay, _middlewares.metricFormat, _middlewares.compress, _middlewares.metricReport)); // 初始化时将离线缓存的异常数据上报

    _interceptor.default.applyMiddleware(_middlewares.merge, _middlewares.rootFormat, _middlewares.compress, _middlewares.rootReport, _middlewares.complete)(); // Raven._getCaptureExceptionOptionsFromPlainObject


    (0, _ravenExtend.overrideGetCaptureExceptionOptionsFromPlainObject)();
    return this;
  },
  // 上报异常
  captureException: _ravenExtend.captureException
};
var _default = kepler;
exports.default = _default;